import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function AdminLogin() {
    const { admin, login } = useAuth();
    const [email, setEmail] = useState('admin@kanbr.com');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    if (admin) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            toast.success('Signed in');
            nav('/admin');
        } catch {
            toast.error('Invalid credentials');
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen bg-slate-900 flex items-center justify-center p-6">
            <form onSubmit={submit} className="bg-white p-10 w-full max-w-md border border-slate-200" data-testid="admin-login-form">
                <div className="flex items-center gap-3 mb-8">
                    <div className="w-10 h-10 bg-blue-900 text-white flex items-center justify-center font-display font-bold text-xl">K</div>
                    <div>
                        <div className="font-display font-bold text-slate-900">Kanbr Admin</div>
                        <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">Manufacturing Console</div>
                    </div>
                </div>
                <h1 className="font-display text-3xl font-bold text-slate-900 mb-6">Sign in.</h1>
                <div className="space-y-4">
                    <div>
                        <Label>Email</Label>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required className="mt-1 rounded-none" />
                    </div>
                    <div>
                        <Label>Password</Label>
                        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required className="mt-1 rounded-none" />
                    </div>
                </div>
                <Button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full bg-blue-900 hover:bg-blue-950 rounded-none py-6 mt-8">
                    {busy ? 'Signing in…' : 'Sign in'}
                </Button>
            </form>
        </div>
    );
}
